import React from 'react'
import dayjs from 'dayjs'

const Index = () => {
  const welcomeText = () => {
    const hour = dayjs().hour()
    const text =
      hour < 9
        ? '早上好'
        : hour <= 11
        ? '上午好'
        : hour <= 13
        ? '中午好'
        : hour < 20
        ? '下午好'
        : '晚上好'
    return text
  }

  return (
    <div
      style={{
        fontSize: 24,
        fontWeight: 500,
      }}
    >
      {welcomeText()}, 欢迎使用iKG
    </div>
  )
}

export default Index
